import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  DialogActions,
  FormControl,
  FormGroup,
  Grid,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import Add from "@material-ui/icons/Add";
import Search from "@material-ui/icons/Search";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { SelectValidator } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { mapActionsToProps } from "../../redux/sms/gateway";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import datetimeHelper from "./../../helper/datetime-helper";
import { globalHistory } from "./../../history";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
});

class Gateway extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      name: "",
      note: "",
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalEdit: false,
      modalDelete: false,

      //
      date: "",
    };
  }
  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
    this.props.getProviderSMS();
  }

  listCollumns = [
    { id: "id", numeric: true, disablePadding: false, label: "IP" },
    {
      id: "providerId",
      numeric: true,
      disablePadding: false,
      label: "Nhà cung cấp",
    },
    {
      id: "createdBy.userId",
      numeric: true,
      disablePadding: false,
      label: "Người tạo",
    },
    { id: "note", numeric: true, disablePadding: false, label: "Chú thích" },
    { id: "active", numeric: true, disablePadding: false, label: "Trạng thái" },
    {
      id: "createdAt",
      numeric: true,
      disablePadding: false,
      label: "Thời gian",
    },
    { id: "action", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "id":
            case "providerId":
            case "active":
            case "createdBy.userId":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.countSmsGateway({ where: where });
    this.props.getSmsGateway(filters.order, filters.pageSize, filters.page, {
      where,
    });
  }

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  handleClose = () => {
    this.setState({ modalSend: false, modalEdit: false, modalDelete: false });
  };

  openModalEdit = (item) => {
    this.state.item = item;
    this.setState({ modalEdit: true });
  };

  openModalDelete = (item) => {
    this.state.item = item;
    this.setState({ modalDelete: true });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD HH:mm:ss");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD HH:mm:ss");
    this.setState({ to });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
    };
  };

  handleCreate = () => {
    const { id, name, note } = this.state;
    this.props.createProviderSMS(id, name, note);
    setTimeout(
      function () {
        this.setState({ modalSend: false });
      }.bind(this),
      500
    );
    this.itemInit();
  };

  handleEdit = () => {
    const { id, name, note } = this.state.item;
    this.props.editProviderSMS(id, name, note);
    setTimeout(
      function () {
        this.setState({ modalEdit: false });
      }.bind(this),
      500
    );
  };

  handleDelete = () => {
    this.props.deleteProviderSMS(this.state.item.id);
    setTimeout(
      function () {
        this.setState({ modalDelete: false });
      }.bind(this),
      500
    );
    this.itemInit();
  };

  // Date now
  handleDateNow = () => {
    var date = { currentTime: new Date().toLocaleString() };

    this.setState({
      date: date,
    });
  };

  render() {
    const { classes, listGateway, coutGateway, listProvider } = this.props;
    const { id, name, note, providerId, filters, item, modalDelete, active } =
      this.state;
    const listGatewayResult =
      typeof listGateway === "object"
        ? Object.keys(listGateway).map((key) => listGateway[key])
        : listGateway;
    const listProviderResult =
      typeof listProvider === "object"
        ? Object.keys(listProvider).map((key) => listProvider[key])
        : listProvider;
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <Grid container spacing={24}>
                    <Grid item xs={3}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Id"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.id}
                        name="id"
                        validators={["required"]}
                        errorMessages={[`Không được để trống`]}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <SelectValidator
                        variant="outlined"
                        className={classes.input}
                        label="Nhà cung cấp"
                        onChange={this.handleSearch}
                        name="providerId"
                        value={filters.where.providerId}
                        fullWidth
                        validators={["required"]}
                        errorMessages={[`Không được để trống`]}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                            shrink: true,
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}>
                        {listProviderResult
                          ? listProviderResult.map((item, key) => {
                              return (
                                <MenuItem key={key} value={item.id}>
                                  {item.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </SelectValidator>
                    </Grid>
                    <Grid item xs={3}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Người tạo"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.userId}
                        validators={["required"]}
                        errorMessages={[`Không được để trống`]}
                        name="createdBy.userId"
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Chú thích"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.note}
                        validators={["required"]}
                        errorMessages={[`Không được để trống`]}
                        name="note"
                      />
                    </Grid>
                  </Grid>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container spacing={24}>
                      <Grid item xs={3}>
                        <SelectValidator
                          variant="outlined"
                          className={classes.input}
                          select
                          label="Trạng thái"
                          onChange={this.handleSearch}
                          name="active"
                          value={filters.where.active}
                          inputStyle={classes.hideAutoFillColorStyle}
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                              shrink: true,
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}>
                          <MenuItem>
                            <em>All</em>
                          </MenuItem>
                          <MenuItem key="ANSWERED" value="ANSWERED">
                            True
                          </MenuItem>
                          <MenuItem key="NO ANSWER" value="NO ANSWER">
                            False
                          </MenuItem>
                        </SelectValidator>
                      </Grid>
                      <Grid item xs={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian bắt đầu"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.from}
                          maxDate={new Date()}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeStart}
                          name="from"
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian kết thúc"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.to}
                          maxDate={this.state.date}
                          minDate={filters.where.from}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeEnd}
                          name="to"
                        />
                      </Grid>

                      <Grid item xs={3}>
                        <Fab
                          color="secondary"
                          aria-label="Search"
                          className={classes.fab}
                          onClick={this.handleSubmit}>
                          <Search />
                        </Fab>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách SMS Gateway"
          items={listGatewayResult}
          rowsPerPage={filters.pageSize}
          count={coutGateway ? coutGateway.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          allowCreate={true}
          handleEdit={this.openModalEdit}
          handleDelete={this.openModalDelete}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          createAction={
            <Fab
              color="secondary"
              aria-label="add"
              className={classes.fab}
              onClick={this.openDialogCreate}>
              <Add className={classes.add} />
            </Fab>
          }
        />
        <Dialog
          open={this.state.modalSend}
          onClose={this.handleClose}
          title="Tạo SMS Provider"
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleCreate}
              onError={(errors) => console.log(errors)}>
              <TextValidator
                variant="outlined"
                className={classes.input}
                label="Id"
                onChange={this.handleChangeText("id")}
                name="id"
                value={id}
                fullWidth
                validators={["required"]}
                errorMessages={[`Không được để trống`]}
              />
              <SelectValidator
                variant="outlined"
                className={classes.input}
                label="Nhà cung cấp"
                onChange={this.handleChangeText("providerId")}
                name="providerId"
                value={providerId}
                fullWidth
                validators={["required"]}
                errorMessages={[`Không được để trống`]}>
                {listProviderResult
                  ? listProviderResult.map((item, key) => {
                      return (
                        <MenuItem key={key} value={item.id}>
                          {item.name}
                        </MenuItem>
                      );
                    })
                  : null}
              </SelectValidator>
              <TextValidator
                variant="outlined"
                className={classes.input}
                label="Tên"
                onChange={this.handleChangeText("name")}
                name="name"
                value={name}
                fullWidth
                validators={["required"]}
                errorMessages={[`Không được để trống`]}
              />
              <TextValidator
                variant="outlined"
                className={classes.input}
                label="Chú thích"
                onChange={this.handleChangeText("note")}
                name="note"
                value={note}
                fullWidth
                validators={["required"]}
                errorMessages={[`Không được để trống`]}
              />
              <SelectValidator
                variant="outlined"
                className={classes.input}
                label="Trạng thái"
                onChange={this.handleChangeText("active")}
                name="active"
                value={active}
                fullWidth
                validators={["required"]}
                errorMessages={[`Không được để trống`]}>
                <MenuItem key={"true"} value={"true"}>
                  True
                </MenuItem>
                <MenuItem key={"false"} value={"false"}>
                  False
                </MenuItem>
              </SelectValidator>
              <DialogActions>
                <Button
                  onClick={this.handleClose}
                  color="primary"
                  variant="contained">
                  Hủy{" "}
                </Button>
                <Button type="submit" color="secondary" variant="contained">
                  Đồng ý{" "}
                </Button>
              </DialogActions>
            </ValidatorForm>
          }
        />
        <Dialog
          open={this.state.modalEdit}
          title={"Chỉnh sửa"}
          input={
            this.state.item ? (
              <ValidatorForm
                ref="form"
                onSubmit={this.handleEdit}
                onError={(errors) => console.log(errors)}>
                <TextValidator
                  variant="outlined"
                  className={classes.input}
                  label="Id"
                  onChange={this.handleChangeTextEdit("id")}
                  name="id"
                  value={item.id}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  validators={["required"]}
                  errorMessages={[`Không được để trống`]}
                />
                <SelectValidator
                  variant="outlined"
                  className={classes.input}
                  label="Nhà cung cấp"
                  onChange={this.handleChangeTextEdit("providerId")}
                  name="providerId"
                  value={item.providerId}
                  fullWidth
                  validators={["required"]}
                  errorMessages={[`Không được để trống`]}>
                  {listProviderResult
                    ? listProviderResult.map((item, key) => {
                        return (
                          <MenuItem key={key} value={item.id}>
                            {item.name}
                          </MenuItem>
                        );
                      })
                    : null}
                </SelectValidator>
                <TextValidator
                  variant="outlined"
                  className={classes.input}
                  label="Người tạo"
                  onChange={this.handleChangeTextEdit("createby")}
                  name="createby"
                  value={item.createby}
                  fullWidth
                  validators={["required"]}
                  errorMessages={[`Không được để trống`]}
                />
                <TextValidator
                  variant="outlined"
                  className={classes.input}
                  label="Chú thích"
                  onChange={this.handleChangeTextEdit("note")}
                  name="note"
                  value={item.note}
                  fullWidth
                  validators={["required"]}
                  errorMessages={[`Không được để trống`]}
                />
                <SelectValidator
                  variant="outlined"
                  className={classes.input}
                  label="Trạng thái"
                  onChange={this.handleChangeTextEdit("active")}
                  name="active"
                  value={item.active}
                  fullWidth
                  validators={["required"]}
                  errorMessages={[`Không được để trống`]}>
                  <MenuItem key={"true"} value={"true"}>
                    True
                  </MenuItem>
                  <MenuItem key={"false"} value={"false"}>
                    False
                  </MenuItem>
                </SelectValidator>
                <TextValidator
                  variant="outlined"
                  className={classes.input}
                  label="Kết nối"
                  onChange={this.handleChangeText("note")}
                  name="note"
                  multiline
                  rows={10}
                  value={JSON.stringify(item.connection, null, "\t")}
                  fullWidth
                  validators={["required"]}
                  errorMessages={[`Không được để trống`]}
                />
                <DialogActions>
                  <Button
                    onClick={this.handleClose}
                    color="primary"
                    variant="contained">
                    Hủy{" "}
                  </Button>
                  <Button type="submit" color="secondary" variant="contained">
                    Đồng ý{" "}
                  </Button>
                </DialogActions>
              </ValidatorForm>
            ) : null
          }
          onClose={this.handleClose}
        />
        <Dialog
          open={modalDelete}
          title={`Bạn có muốn xóa dữ liệu?`}
          button={true}
          onSubmit={this.handleDelete}
          onClose={this.handleClose}
        />
      </React.Fragment>
    );
  }
}

Gateway.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listGateway: state.sms.gateway,
  listProvider: state.sms.provider,
  coutGateway: state.sms.count,
});

Gateway = connect(mapStateToProps, mapActionsToProps)(Gateway);

export default withStyles(styles)(Gateway);
